import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WsButtonComponent } from './ws-button/ws-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from "@angular/material/button";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from '@angular/material/paginator';
import { DwsPermissionDirectiveModule } from '@util/directives/dwsPermission/dws-permission.module';
import { DurationModule } from '@web/app/pipes/duration/duration.module';
import { TranslateDomainModule } from '@web/app/pipes/translate/translate-domain.module';
import { LoadingModule } from '@web/app/components/loading/loading.module';
import { WsSelectorComponent } from './ws-selector/ws-selector.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { WsDatepickerComponent } from './ws-datepicker/ws-datepicker.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WsActionsComponent } from './ws-actions/ws-actions.component';
import { WsPeriodNavigatorComponent } from './ws-period-navigator/ws-period-navigator.component';
import { WsCheckboxComponent } from './ws-checkbox/ws-checkbox.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { WsToggleComponent } from './ws-toggle/ws-toggle.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { WsDialogComponent } from './ws-dialog/ws-dialog.component';
import { WsInputComponent } from './ws-input/ws-input.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatChipsModule } from '@angular/material/chips';
import { WsChipComponent } from './ws-chip/ws-chip.component';
import { WsInfoCardComponent } from './ws-info-card/ws-info-card.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { InfoIconHoverableModule } from '@web/app/components/info-icon-hoverable/info-icon-hoverable.module';
import { WsDurationComponent } from './ws-duration/ws-duration.component';
import { WsFlagComponent } from './ws-flag/ws-flag.component';
import { WsSearchbarModule } from './ws-searchbar/ws-searchbar.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { WsTimeInputComponent } from './ws-time-input/ws-time-input.component';
import { WsTruncatedTextComponent } from './ws-truncated-text/ws-truncated-text.component';
import { MatSelectModule } from '@angular/material/select';
import { MatDividerModule } from '@angular/material/divider';
import { WsTooltipModule } from './ws-tooltip/ws-tooltip.module';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    LoadingModule,
    TranslateModule,
    DurationModule,
    TranslateDomainModule,
    DwsPermissionDirectiveModule,
    MatPaginatorModule,
    MatButtonModule,
    MatTableModule,
    MatIconModule,
    MatMenuModule,
    MatDatepickerModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatSlideToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatGridListModule,
    MatAutocompleteModule,
    MatSelectModule,
    OverlayModule,
    PortalModule,
    WsTooltipModule,
    InfoIconHoverableModule,
    WsSearchbarModule,
    MatDividerModule
  ],
  declarations: [
    WsButtonComponent,
    WsSelectorComponent,
    WsDatepickerComponent,
    WsActionsComponent,
    WsPeriodNavigatorComponent,
    WsCheckboxComponent,
    WsToggleComponent,
    WsDialogComponent,
    WsInputComponent,
    WsChipComponent,
    WsInfoCardComponent,
    WsDurationComponent,
    WsFlagComponent,
    WsTimeInputComponent,
    WsTruncatedTextComponent
  ],
  exports: [
    WsButtonComponent,
    WsSelectorComponent,
    WsDatepickerComponent,
    WsActionsComponent,
    WsPeriodNavigatorComponent,
    WsCheckboxComponent,
    WsToggleComponent,
    WsDialogComponent,
    WsInputComponent,
    WsChipComponent,
    WsInfoCardComponent,
    WsDurationComponent,
    WsFlagComponent,
    WsTimeInputComponent,
    WsTruncatedTextComponent,
    WsSearchbarModule,
    WsTooltipModule
  ]
})
export class WsUiModule { }